var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "element-value",
          rawName: "v-element-value",
          value: _vm._value,
          expression: "_value",
        },
      ],
      staticClass: "hkl-checkbox",
    },
    [
      _c(
        "input",
        _vm._g(
          _vm._b(
            {
              attrs: { type: "checkbox" },
              domProps: { checked: _vm.checked },
              on: { change: _vm.change },
            },
            "input",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm.$slots.default
        ? _c(
            "div",
            {
              on: {
                click: function () {
                  return !_vm.$attrs.disabled && _vm.change()
                },
              },
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }